"use client";

import CartSidebar from "@/app/products/components/CartSidebar";

export default function CartSidebarWrapper() {
  return <CartSidebar />;
}
